import { createSlice, PayloadAction } from '@reduxjs/toolkit'
interface Loading {
    isLoading: boolean
}

export type LoadingState = Loading;

const loadingSlice = createSlice({
    name: 'loading',
    initialState: { isLoading: false } as LoadingState,
    reducers: {
        change(state, action: PayloadAction<Loading>) {
            state.isLoading = action.payload.isLoading;
        },
    }
});

export const { change } = loadingSlice.actions;
export default loadingSlice.reducer;